import { fetchJSON } from "@/src/requests/utils/fetch-json";

export type ServiceLineOption = {
  value: string;
  label: string;
};

export function getServiceLines(): Promise<ServiceLineOption[]> {
  return fetchJSON<ServiceLineOption[]>("/api/service-lines");
}
